<dt-modal-content (closeClick)="close(false)" #modalContent [size]="'small'">
  <ng-template #title i18n>Moduswechsel von Professional nach Educational</ng-template>
  <ng-template #content>
    <div class="content">
      <p i18n>Wähle einen Einstiegspunkt:</p>
      <div class="step-choosing-container">
        <dt-vertical-slider
          [positions]="stepLabels"
          [disabledPositions]="disabledSteps"
          [tooltipsForDisabled]="tooltipsForDisabledSteps"
          [(selectedPosition)]="indexOfChosenStep"
        >
        </dt-vertical-slider>
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" i18n (click)="close(true)">Wechseln</button>
    <button mat-raised-button color="accent-less" i18n (click)="close(false)">Abbrechen</button>
  </ng-template>
</dt-modal-content>
